import React, { Component } from 'react';
import { connect } from 'react-redux';
import { batchSearchData, batchFormData, batchTableData, getMultiLangText, getMultiLangValues } from './utilService';
import { Table, Input, Checkbox } from 'antd';
import { toggleFormula, setFormulaInfo, setCurrentBatchCell } from 'Store/ZoneSetting/action';
import { handleFormula } from "./events";
import CoverPosotion from "Components/CoverPosition";
import _ from 'lodash';
import {
    EditableCell,
    EditableCheck,
    SelectCell,
    FormulaCell,
    MultiLangCell
} from './editableCell';
import platform from "Pub/js/platform";
const { getLangCode } = platform;

// import { throttle } from "Pub/js/utils";

const { NCCheckbox, NCTable } = platform.base;
const Search = Input.Search;
// //单元格增加自动化测试标记
// const renderCommonCell = (el, fieldid, cls) => (
//     <div fieldid={fieldid} className={cls}>{el}</div>
// )
// //自动化测试标记表头单元格
// const FieldidHeaderCell = props => {
//     const { fieldid, ...restProps } = props;
//     return <th {...restProps} >{renderCommonCell(restProps.children, fieldid)}</th>;
// };

// //自动化测试标记单元格
// const FieldidCell = props => {
//     const { fieldid, record, searchActives = {}, searchSelect = {}, ...restProps } = props,
//         code = record.code,
//         { name, value, key } = searchActives[code] || {};
//     let fieldValue = record[fieldid];
//     let cls = '';
//     if (fieldid === 'label') {
//         fieldValue = getMultiLangText(record, fieldid, props.multiOptions);
//     }
//     if (key && fieldid == name && fieldValue && String(fieldValue).indexOf(key) != '-1') {
//         cls += searchActives[code]['activeCls'];
//         cls += searchSelect[code] ? searchActives[code]['selectCls'] : '';
//     }
//     let renderTd = renderCommonCell(props.children, fieldid, cls);
//     if (props.children[2] === undefined) {
//         renderTd = <div fieldid={fieldid} className={cls}><span>&nbsp;</span></div>
//     }
//     return (
//         <td {...restProps}>{renderTd}</td>
//     );
// }
//批量设置组件类
//基于ant的table组件的封装
class BatchTable extends Component {
    constructor(props) {
        super(props);
        this.columns = [];
        this.state = {
            visible: false,
        };
    }
    //input下拉框的显示/隐藏
    //注：未启用该下拉
    handleVisibleChange = (visible, index) => {
        if (visible === false) {
            return;
        }
        this.setState({ [`visible${index}`]: visible });
    };
    //input下拉框的隐藏
    //注：未启用该下拉
    hidePopover = index => {
        this.setState({ [`visible${index}`]: false });
    };
    /**
     * 闭包 只对具体的单元格修改，需要知道更新具体哪一行（横向）&哪一个属性（纵向）
     * @param {index} 需要知道更新数据所在行，比如index=0为第一行
     * @param {property} 需要知道更新数据所归属属性，比如code为更新编码
     * @param {type} 需要知道更新字段的类型，比如特殊类型formula为公式编辑器
     * @return {function} 返回方法体，调用的地方传入需要更改的value值
     */
    onCellChange = (index, property, type) => {
        return value => {
            let { newSource } = this.props;
            newSource = _.cloneDeep(newSource);
            let target = newSource[index];
            if (target) {
                if (type === 'multilang') {
                    newSource[index] = { ...target, ...value };
                } else {
                    target[property] = value;
                }

                this.props.saveNewSource(newSource, property, type);
            }
        };
    };
    /**
     * 闭包 只对具体的单元格修改，需要知道更新具体哪一行（横向）&哪一个属性（纵向）
     * @param {index} 需要知道更新数据所在行，比如index=0为第一行
     * @param {property} 需要知道更新数据所归属属性，比如code为更新编码
     * @return {function} 返回方法体，调用的地方传入需要更改的value值
     */
    onCheckedChange = (index, property) => {
        return value => {
            let { newSource } = this.props;
            newSource = _.cloneDeep(newSource);
            let target = newSource[index];
            if (target) {
                target[property] = value;
                this.props.saveNewSource(newSource);
            }
        };
    };
    /**
     * 闭包 一纵列单元格修改，需要知道更新哪一个属性
     * @param {property} 需要知道更新数据所归属属性，比如code为更新编码
     * @return {function} 返回方法体，调用的地方传入需要更改的value值
     */
    onAllColCellChange = property => {
        return value => {
            this.saveAllCellValue(value, property);
        };
    };
    /**
     * 保存一纵列单元格
     * @param {value} 需要更新的值
     * @param {property} 需要更新的属性key
     */
    saveAllCellValue = (value, property) => {
        let { newSource } = this.props;
        newSource = _.cloneDeep(newSource);
        _.forEach(newSource, n => {
            n[property] = value;
        });
        this.props.saveAllNewSource(newSource, property, value);
    };


    /**
     * 中间态公共方法
     * @param {arr} 创建的新数组
     * @param {region} 需要更新的区域（表单/表格/查询）
     * @param {property} 每个区域需要更新的属性
     */
    publicIndeterminate = (arr, region, property) => {
        arr = this.props.batchSource.map(item => item[property]); //需要从全部批量设置数据判断全选checkbox选中状态
        if (arr.some(a => a === true) && !arr.every(a => a === true)) {
            _.forEach(region, (bat, i) => {
                if (bat.property == property) {
                    bat.indeterminate = true;
                    bat.checkAll = false;
                }
                return;
            })
        } else if (!arr.includes(true)) {
            _.forEach(region, (bat, i) => {
                if (bat.property == property) {
                    bat.indeterminate = false;
                    bat.checkAll = false;
                }
                return;
            })
        } else {
            _.forEach(region, (bat, i) => {
                if (bat.property == property) {
                    bat.indeterminate = false;
                    bat.checkAll = true;
                }
                return;
            })
        }
        arr = [];
    }
    componentDidMount() {
        // this.scrollEvent()
    }
    // 滚动事件
    scrollEvent() {
        const table = document.querySelector('.batch-setting-tabs .ant-table-body')
        // Table 组件滚动时 解决错位问题
        if (table.scrollHeight > table.clientHeight) {
            table.addEventListener('wheel', this.addBodyAreaScrollWheelEvent);
        }
    }
    addBodyAreaScrollWheelEvent = (event => {
        let { currentTarget, deltaX, deltaY } = event;
        if (Math.abs(deltaX) < Math.abs(deltaY)) {
            try {
                let $parentElement = currentTarget,
                    $scrollElement = null;
                if ($parentElement) {
                    if ($parentElement.scrollHeight > $parentElement.clientHeight) {
                        // 当dom的实际高度 > 看到的高度
                        $scrollElement = $parentElement;
                    }
                }


                if ($scrollElement) {
                    event.preventDefault(); // 阻止默认的滚动事件，手动加上滚动
                    $scrollElement.scrollTop = $scrollElement.scrollTop + deltaY / 2;
                }
            } catch (error) {
                console.error(error);
            }
        }
    })
    // 搜索高亮
    FieldidCell = (record, index, column) => {
        const { fieldid, searchActives = {}, searchSelect = {}, ...restProps } = this.props,
            { code } = record;
        // { name, value, key } = searchActives[code] || {};
        let cls = '';
        if (searchActives[code] && searchActives[code].name === 'label' && column.dragIndex === 1) {
            cls += searchActives[code]['activeCls'];
            cls += searchSelect[code] ? searchActives[code]['selectCls'] : '';
        }
        return cls;
    }
    render() {
        let { newSource, areatype, searchActives = {}, searchSelect = {}, multiOptions } = this.props;
        //给每一个卡片添加table渲染所需的唯一key
        _.forEach(newSource, (n, i) => {
            n.key = [n.areaid, n.code].join('_')
        });
        let columns = [];
        let scrollTableWidth = 0;
        let batchData = [];
        //查询区、表单区、表格区，根据区域类型的不同，进行不同的赋值，从utilService中获取字典
        if (areatype === '0') {
            let isnotmetaArr = [], isuseArr = [],
                disabledArr = [], visibleArr = [],
                ismultiselectedenabledArr = [], isfixedconditionArr = [],
                requiredArr = [], isqueryconditionArr = [],
                containlowerArr = [], ischeckArr = [],
                isbeyondorgArr = [], usefuncArr = [];
            //查询区
            batchData = batchSearchData();
            this.props.ismobile && _.remove(batchData, item => ['isuse', 'visibleposition', 'isfixedcondition', 'containlower', 'ischeck', 'isbeyondorg', 'usefunc'].includes(item.property)); // 移动模板隐藏部分属性
            _.forEach(newSource, (vv, indx) => {
                isnotmetaArr.push(vv.isnotmeta);
                isuseArr.push(vv.isuse);
                disabledArr.push(vv.disabled);
                visibleArr.push(vv.visible);
                ismultiselectedenabledArr.push(vv.ismultiselectedenabled);
                isfixedconditionArr.push(vv.isfixedcondition);
                requiredArr.push(vv.required);
                isqueryconditionArr.push(vv.isquerycondition);
                containlowerArr.push(vv.containlower);
                ischeckArr.push(vv.ischeck);
                isbeyondorgArr.push(vv.isbeyondorg);
                usefuncArr.push(vv.usefunc);
            });
            this.publicIndeterminate(isnotmetaArr, batchData, 'isnotmeta')
            this.publicIndeterminate(isuseArr, batchData, 'isuse')
            this.publicIndeterminate(disabledArr, batchData, 'disabled')
            this.publicIndeterminate(visibleArr, batchData, 'visible')
            this.publicIndeterminate(ismultiselectedenabledArr, batchData, 'ismultiselectedenabled')
            this.publicIndeterminate(isfixedconditionArr, batchData, 'isfixedcondition')
            this.publicIndeterminate(requiredArr, batchData, 'required')
            this.publicIndeterminate(isqueryconditionArr, batchData, 'isquerycondition')
            this.publicIndeterminate(containlowerArr, batchData, 'containlower')
            this.publicIndeterminate(ischeckArr, batchData, 'ischeck')
            this.publicIndeterminate(isbeyondorgArr, batchData, 'isbeyondorg')
            this.publicIndeterminate(usefuncArr, batchData, 'usefunc')
        } else if (areatype === '1') {
            let isreviseArr = [], isnextrowArr = [],
                visibleArr = [], requiredArr = [],
                disabledArr = [];
            //表单
            batchData = batchFormData();
            _.forEach(newSource, (vv, indx) => {
                isreviseArr.push(vv.isrevise);
                isnextrowArr.push(vv.isnextrow);
                visibleArr.push(vv.visible);
                requiredArr.push(vv.required);
                disabledArr.push(vv.disabled);
            });
            this.publicIndeterminate(isreviseArr, batchData, 'isrevise');
            this.publicIndeterminate(isnextrowArr, batchData, 'isnextrow');
            this.publicIndeterminate(visibleArr, batchData, 'visible');
            this.publicIndeterminate(requiredArr, batchData, 'required');
            this.publicIndeterminate(disabledArr, batchData, 'disabled');

        } else {
            let isreviseArr = [], istotalArr = [],
                visibleArr = [], requiredArr = [],
                disabledArr = [];
            //表格
            batchData = batchTableData();
            _.forEach(newSource, (vv, indx) => {
                isreviseArr.push(vv.isrevise);
                istotalArr.push(vv.istotal);
                visibleArr.push(vv.visible);
                requiredArr.push(vv.required);
                disabledArr.push(vv.disabled);
            });
            this.publicIndeterminate(isreviseArr, batchData, 'isrevise');
            this.publicIndeterminate(istotalArr, batchData, 'istotal');
            this.publicIndeterminate(visibleArr, batchData, 'visible');
            this.publicIndeterminate(requiredArr, batchData, 'required');
            this.publicIndeterminate(disabledArr, batchData, 'disabled');
        }
        //循环批量设置的字典，
        _.forEach(batchData, (data, index) => {
            let tmpColData = {
                dataIndex: data.property,
                width: data.width
            };
            if (tmpColData.dataIndex === 'label') {
                tmpColData.fixed = 'left';
            }
            if (tmpColData.dataIndex === 'code') {
                tmpColData.fixed = 'left';
            }
            //累加宽度，计算scroll值
            scrollTableWidth += data.width;
            //input的下拉框进行一纵列批改，
            //勿删，可能后期会使用
            //<Popover
            //     overlayClassName="all-apps-popover"
            //     getPopupContainer={() => {
            //         return document.querySelector(
            //             ".zonesetting-batch-setting-modal"
            //         );
            //     }}
            //     content={
            //         <EditAllCell
            //             property={data.property}
            //             hidePopover={()=>{this.hidePopover(index)}}
            //             onChange={this.onAllColCellChange(
            //                 data.property
            //             )}
            //         />
            //     }
            //     visible={this.state[`visible${index}`]}
            //     onVisibleChange={(visible)=>{this.handleVisibleChange(visible,index)}}
            //     placement="bottomLeft"
            //     trigger="click"
            // >
            //     {data.title} <Icon type="down" />
            // </Popover>

            // console.log('batchData', batchData);
            // console.log('tmpColData', tmpColData);
            //根据类型不同，渲染不同的表头单元格
            if (data.type === 'checkbox') {
                //如果是checkbox，则表头为控制全选与否的checkbox组件
                tmpColData.title = (
                    <NCCheckbox
                        onChange={val => {
                            this.saveAllCellValue(
                                val,
                                data.property
                            );
                        }}
                        indeterminate={data.indeterminate}
                        checked={data.checkAll}
                        ref={ref => this.props.forwardRef(data.property, {
                            checked: data.checkAll,
                            indeterminate: data.indeterminate //checkbox是否中间态
                        })} //将全选checkbox选中状态传给父组件
                    >
                        {data.title}
                    </NCCheckbox>
                );
            } else {
                //其他类型，表头都是静态文本
                tmpColData.title = data.title;
            }
            //根据类型不同，渲染不同的表体单元格
            switch (data.type) {
                case 'multilang':
                    tmpColData.render = (value, record, index) => {
                        let itemValue = getMultiLangValues(record, data.property, this.props.multiOptions);
                        return (
                            <MultiLangCell
                                value={itemValue}
                                property={data.property}
                                updateValue={this.onCellChange(
                                    index,
                                    data.property,
                                    data.type
                                )}
                                multiOptions={multiOptions}
                            />
                        )
                    }
                    break;
                case 'input':
                    tmpColData.render = (text, record, index) => {
                        //如果组件长度为null或者''时设置默认显示值为120
                        if (data.property === 'width' && !text) {
                            text = '120';
                        }
                        return (
                            <EditableCell
                                value={text}
                                property={data.property}
                                updateValue={this.onCellChange(
                                    index,
                                    data.property
                                )}
                            />
                        );
                    };
                    break;
                case 'checkbox':
                    tmpColData.render = (text, record, index) => {
                        return (
                            <EditableCheck
                                value={text}
                                property={data.property}
                                onChange={this.onCellChange(
                                    index,
                                    data.property
                                )}
                            />
                        );
                    };
                    break;
                case 'select':
                    tmpColData.render = (text, record, index) => {
                        return (
                            <SelectCell
                                selectValue={text}
                                property={data.property}
                                selectObj={data.selectObj}
                                onChange={this.onCellChange(
                                    index,
                                    data.property
                                )}
                            />
                        );
                    };
                    break;
                case 'text':
                    tmpColData.title = data.title;
                    break;
                case 'formula': //公式
                    tmpColData.render = (text, record, index) => {
                        let handleFormulaClick = () => {
                            if (!this.props.formula[data.property].visible) {
                                handleFormula.call(this, newSource[index]);
                                this.props.toggleFormula(data.property, { visible: true, value: text });
                            }
                            this.props.setCurrentBatchCell({ index, code: data.property });
                        }
                        return <FormulaCell
                            value={text}
                            property={data.property}
                            onFormula={handleFormulaClick}
                            updateValue={this.onCellChange(
                                index,
                                data.property,
                                'formula'
                            )}
                        />
                    };
                    break;
            }
            //将所有结果压栈columns中，ant-table即可进行table渲染
            columns.push(tmpColData);
        });
        const newColumns = columns.map(col => {
            const fieldid = col.dataIndex || col.key; //自动化测试标记
            return {
                ...col,
                onCell: record => ({ fieldid, record, searchActives, searchSelect, multiOptions }),
                onHeaderCell: column => ({ fieldid })
            };
        });
        // console.log(newColumns)
        // console.log(newSource)
        return (
            <NCTable
                className="batch-setting-table"
                bordered
                data={newSource}
                columns={newColumns}
                scroll={{ x: scrollTableWidth, y: `${document.body.clientHeight - 110 - 200}px` }}
                getCellClassName={this.FieldidCell}
                lazyload={JSON.stringify(searchActives) === '{}'}
                adaptionHeight={true}
                otherAreaHeight={120}
            />
            // <Table
            //     className="batch-setting-table"
            //     bordered
            //     dataSource={newSource}
            //     columns={newColumns}
            //     components={{
            //         header: {
            //             cell: FieldidHeaderCell
            //         },
            //         body: {
            //             cell: FieldidCell
            //         }
            //     }}
            //     pagination={false}
            //     // 还需要减去多页签的高度
            //     scroll={{ x: scrollTableWidth, y: `${document.body.clientHeight - 110 - 200}px` }}
            //     locale={{
            //         emptyText: (
            //             <CoverPosotion type="treeCardTable" />
            //         )
            //     }}
            // />
        );
    }
}

export default connect(
    state => ({
        formula: state.zoneSettingData.formula,
        areaList: state.zoneSettingData.areaList,
        ismobile: state.zoneSettingData.ismobile
    }), {
    toggleFormula,
    setFormulaInfo,
    setCurrentBatchCell
}
)(BatchTable);
